import { countries, type JobSearchCardOption } from "../../jobSearchCardUtils";

export class JobSearchCardRuntime extends HTMLElement {
    private form: HTMLFormElement;

    private submit(e: SubmitEvent) {
        e.preventDefault();

        const form = e.target as HTMLFormElement;
        const elements = form.elements;

        for (let i = 0; i < elements.length; i++) {
            const input = elements[i] as HTMLInputElement;
            if (input.value.trim() === "") {
                input.removeAttribute("name");
            }
        }

        const country = this.dataset.country;
        const language = this.dataset.language;
        const keyword = elements['job-search__input'].value.trim();

        if (country && language) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'job_position_search_landing_page',
                eventCategory: 'Job search landing page',
                eventAction: countries.find(({key}: JobSearchCardOption) => key === country).value,
                eventLabel: language,
                keyword: keyword || "not_present"
            });
        }

        form.submit();
    }

    public async connectedCallback() {
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.submit);
    }

    public disconnectedCallback() {
        this.form?.removeEventListener('submit', this.submit);
    }
}